import LoginComponent from "../components/LoginComponent/LoginComponent";

const User = ({ state = 'login', onLogin }) => {
    return (
        <div>
          <LoginComponent onLogin={onLogin} />
        </div>
    );
};

export default User;
